export default "__VITE_ASSET__BkT3D4nS__"